/**
 * Start Node Component
 */
import React, { memo } from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { Play } from 'lucide-react';
import styles from './Nodes.module.css';

export const StartNode: React.FC<NodeProps> = memo(({ data, selected }) => {
  return (
    <div className={`${styles.node} ${styles.startNode} ${selected ? styles.selected : ''}`}>
      <div className={styles.nodeContent}>
        <div className={styles.nodeIcon} style={{ backgroundColor: '#10b981' }}>
          <Play size={16} color="white" />
        </div>
        <span className={styles.nodeLabel}>{data.label || 'Start'}</span>
      </div>
      <Handle
        type="source"
        position={Position.Right}
        className={styles.handle}
      />
    </div>
  );
});

StartNode.displayName = 'StartNode';
